var _line, _line2, _line3, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEventsIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 49.6369,
    y1: 51.771,
    x2: 26.6369,
    y2: 70.771,
    stroke: "black",
    strokeWidth: 2
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 49.59,
    y1: 13.8074,
    x2: 23.59,
    y2: 32.8074,
    stroke: "black",
    strokeWidth: 2
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 45.3886,
    y1: 49.7913,
    x2: 23.3886,
    y2: 32.7913,
    stroke: "black",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35 73.5C35 73.9935 34.726 74.5952 33.9362 75.2696C33.1501 75.9407 31.9537 76.5903 30.3883 77.1556C27.2658 78.2832 22.886 79 18 79C13.114 79 8.73425 78.2832 5.61172 77.1556C4.04625 76.5903 2.84994 75.9407 2.06384 75.2696C1.27397 74.5952 1 73.9935 1 73.5C1 73.0065 1.27397 72.4048 2.06384 71.7304C2.84994 71.0593 4.04625 70.4097 5.61172 69.8444C8.73425 68.7168 13.114 68 18 68C22.886 68 27.2658 68.7168 30.3883 69.8444C31.9537 70.4097 33.1501 71.0593 33.9362 71.7304C34.726 72.4048 35 73.0065 35 73.5Z",
    fill: "#F4EFE9",
    stroke: "black",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27 31.5C27 32.104 26.4077 32.9839 24.6607 33.7701C23.0075 34.514 20.6535 35 18 35C15.3465 35 12.9925 34.514 11.3393 33.7701C9.59225 32.9839 9 32.104 9 31.5C9 30.896 9.59225 30.0161 11.3393 29.2299C12.9925 28.486 15.3465 28 18 28C20.6535 28 23.0075 28.486 24.6607 29.2299C26.4077 30.0161 27 30.896 27 31.5Z",
    fill: "#F4EFE9",
    stroke: "black",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M65 13.5C65 14.104 64.4077 14.9839 62.6607 15.7701C61.0075 16.514 58.6535 17 56 17C53.3465 17 50.9925 16.514 49.3393 15.7701C47.5923 14.9839 47 14.104 47 13.5C47 12.896 47.5923 12.0161 49.3393 11.2299C50.9925 10.486 53.3465 10 56 10C58.6535 10 61.0075 10.486 62.6607 11.2299C64.4077 12.0161 65 12.896 65 13.5Z",
    fill: "#F4EFE9",
    stroke: "black",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M79 49.5C79 49.9935 78.726 50.5952 77.9362 51.2696C77.1501 51.9407 75.9537 52.5903 74.3883 53.1556C71.2658 54.2832 66.886 55 62 55C57.114 55 52.7342 54.2832 49.6117 53.1556C48.0463 52.5903 46.8499 51.9407 46.0638 51.2696C45.274 50.5952 45 49.9935 45 49.5C45 49.0065 45.274 48.4048 46.0638 47.7304C46.8499 47.0593 48.0463 46.4097 49.6117 45.8444C52.7342 44.7168 57.114 44 62 44C66.886 44 71.2658 44.7168 74.3883 45.8444C75.9537 46.4097 77.1501 47.0593 77.9362 47.7304C78.726 48.4048 79 49.0065 79 49.5Z",
    fill: "#F4EFE9",
    stroke: "black",
    strokeWidth: 2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14 56C14 55.4477 14.4477 55 15 55H21C21.5523 55 22 55.4477 22 56V74H14V56Z",
    fill: "#F4EFE9",
    stroke: "black",
    strokeWidth: 2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22 74V60.8042L26.59 63.673C27.4671 64.2212 28 65.1826 28 66.217V73C28 73.5523 27.5523 74 27 74H22Z",
    fill: "#F4EFE9",
    stroke: "black",
    strokeWidth: 2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M14 74V60.8042L9.41 63.673C8.53286 64.2212 8 65.1826 8 66.217V73C8 73.5523 8.44772 74 9 74H14Z",
    fill: "#F4EFE9",
    stroke: "black",
    strokeWidth: 2
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M14 20C14 18.8954 14.8954 18 16 18H20C21.1046 18 22 18.8954 22 20V30C22 31.1046 21.1046 32 20 32H16C14.8954 32 14 31.1046 14 30V20Z",
    fill: "#FE138F"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M53 2C53 1.44772 53.4477 1 54 1H58C58.5523 1 59 1.44772 59 2V12C59 12.5523 58.5523 13 58 13H54C53.4477 13 53 12.5523 53 12V2Z",
    fill: "#F4EFE9",
    stroke: "black",
    strokeWidth: 2
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M58 32C58 31.4477 58.4477 31 59 31H65C65.5523 31 66 31.4477 66 32V50H58V32Z",
    fill: "#F4EFE9",
    stroke: "black",
    strokeWidth: 2
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M66 50V36.8042L70.59 39.673C71.4671 40.2212 72 41.1826 72 42.217V49C72 49.5523 71.5523 50 71 50H66Z",
    fill: "#F4EFE9",
    stroke: "black",
    strokeWidth: 2
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M58 50V36.8042L53.41 39.673C52.5329 40.2212 52 41.1826 52 42.217V49C52 49.5523 52.4477 50 53 50H58Z",
    fill: "#F4EFE9",
    stroke: "black",
    strokeWidth: 2
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEventsIcon);
export default __webpack_public_path__ + "static/media/events-icon.4305512921702230ddf0df2784fb4f9a.svg";
export { ForwardRef as ReactComponent };